import { CONFIG } from '../../../config'
import { parseToMysqlFormat } from '../../util/date.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/delivery-transfer`

export const urlPostPutDeliveryTransfer = `${BASE_URL}/transfer`

export function urlGetDeliveryTransfer(tp_id, pInicial, pFinal) {
  const dataInicial = `${parseToMysqlFormat(pInicial)} 00:00:00`
  const dataFinal = `${parseToMysqlFormat(pFinal)} 23:59:59`
  return `${BASE_URL}/${tp_id}?pInicial=${dataInicial}&pFinal=${dataFinal}`
}
export function urlGetDeliveriesToBeTransfered(tp_id_origin, transfer_id, pInicial, pFinal) {
  pInicial = `${parseToMysqlFormat(pInicial)} 00:00:00`
  pFinal = `${parseToMysqlFormat(pFinal)} 23:59:59`
  return `${BASE_URL}/deliveries-to-transfer/${tp_id_origin}/${transfer_id}?pInicial=${pInicial}&pFinal=${pFinal}`
}
export function urlGetCargasParadasTransferencia(tp_id_origin, dataInicial, dataFinal) {
  dataInicial = `${parseToMysqlFormat(dataInicial)} 00:00:00`
  dataFinal = `${parseToMysqlFormat(dataFinal)} 23:59:59`
  return `${BASE_URL}/cargas-paradas-transferencia/${tp_id_origin}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`
}
export function urlPostAssocDeliveryStepWithTransfer(tp_id_origin, transfer_id, pInicial, pFinal) {
  pInicial = `${parseToMysqlFormat(pInicial)} 00:00:00`
  pFinal = `${parseToMysqlFormat(pFinal)} 23:59:59`
  return `${BASE_URL}/assoc-delivery-step-with-transfer/${tp_id_origin}/${transfer_id}?pInicial=${pInicial}&pFinal=${pFinal}`
}
export function urlGetDeliveriesForTransferExport(transfer_ids) {
  return `${BASE_URL}/deliveries-for-export/${transfer_ids}`
}
export function urlPutChangeStatusToTransfered(transfer_id, user_id) {
  return `${BASE_URL}/change-status-to-transfered/${transfer_id}/${user_id}`
}
export function urlPutChangeStatusToCanceled(transfer_id, user_id) {
  return `${BASE_URL}/change-status-to-canceled/${transfer_id}/${user_id}`
}
export function urlGetDeliveriesFromTransfer(tp_id) {
  return `${BASE_URL}/deliveries-from-transfer/${tp_id}`
}
export function urlPostReceiveDeliveriesFromTransfer(user_id) {
  return `${BASE_URL}/receive-deliveries-from-transfer/${user_id}`
}
export function urlPutUpdateAvailableToTransfer(delivery_id) {
  return `${BASE_URL}/update-available-to-transfer/${delivery_id}`
}
export function urlReportMapaCarregamentoEstoqueTransferencia(tp_id, transfer_id) {
  return `${BASE_URL}/report-mapa-de-carregamento-estoque/${tp_id}/${transfer_id}?t=${localStorage.getItem('t')}`
}
